import React from 'react';
import { Helmet } from 'react-helmet';
import ContactForm from '../../components/ContactForm/ContactForm';
import CustomerCareTable from '../../components/CustomerCareTable/CustomerCareTable';
import './Contact.css';

const Contact = () => {
  const officeLocations = [
    {
      city: 'Amreli (Head Office)',
      address: 'S-5, Shivam Plaza Complex, Old Marketing Yard, Amreli-365601, Gujarat, India',
      phone: '+91 97248 20358',
      email: 'globalsolar99@gmail.com',
      image: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=600&q=80'
    }
  ];

  const faqs = [
    {
      question: 'How do I get started with solar installation?',
      answer: 'Simply contact us through our contact form, phone, or email. We\'ll schedule a free site assessment to evaluate your property and provide you with a detailed solar proposal including cost savings analysis.'
    },
    {
      question: 'What is the typical solar installation timeline?',
      answer: 'Residential solar installations typically take 1-3 days, while commercial projects can take 1-2 weeks depending on system size. The entire process from consultation to commissioning usually takes 2-4 weeks including permits and approvals.'
    },
    {
      question: 'Do you provide maintenance and support after installation?',
      answer: 'Yes, we offer comprehensive maintenance packages including regular cleaning, performance monitoring, and technical support. Our systems come with 25-year warranty and we provide 24/7 emergency support.'
    },
    {
      question: 'What government subsidies are available for solar?',
      answer: 'We assist with all government subsidy applications including MNRE subsidies, state government incentives, and net metering approvals. Our team handles all documentation and ensures you get maximum benefits available.'
    },
    {
      question: 'What types of solar systems do you install?',
      answer: 'We specialize in grid-tied solar systems, off-grid systems with battery backup, hybrid systems, and commercial solar installations. We use high-quality panels from top manufacturers with smart inverter technology.'
    },
    {
      question: 'How much can I save with solar energy?',
      answer: 'Most customers save 70-90% on their electricity bills. With our financing options and government subsidies, the payback period is typically 3-5 years, after which you enjoy free electricity for 20+ years.'
    }
  ];

  return (
    <>
      <Helmet>
        <title>Contact Global Solar Energy - Get Free Solar Consultation</title>
        <meta name="description" content="Contact Global Solar Energy for free solar consultation. Leading solar installation company in Gujarat. Get quotes for residential and commercial solar systems." />
        <meta name="keywords" content="contact solar company, solar consultation Gujarat, solar installation quote, Global Solar Energy contact" />
      </Helmet>

      <div className="contact-page">
        {/* Hero Section */}
        <section className="contact-hero" style={{backgroundImage: `url('/images/Hero%20image/Contactpag.jpeg')`}}>
          <div className="contact-hero-overlay"></div>
          <div className="contact-hero-content">
            <h1 className="contact-hero-title">Contact</h1>
          </div>
        </section>

        {/* Contact Form and Info */}
        <section className="section contact-main">
          <div className="container">
            <div className="contact-content">
              <div className="contact-form-section">
                <div className="section-header">
                  <h2>Get Free Solar Consultation</h2>
                  <p>Fill out the form below and we'll provide you with a free solar assessment within 24 hours</p>
                </div>
                <ContactForm title="Contact Us" showSubject={true} />
              </div>
            </div>
          </div>
        </section>


        {/* Office Locations */}
        <section className="section office-locations">
          <div className="container">
            <div className="section-header text-center">
              <h2>Our Solar Center</h2>
              <p>Visit our state-of-the-art solar center in Amreli for comprehensive solar energy solutions</p>
            </div>
            
            {/* Enhanced Office Card */}
            <div className="enhanced-office-section">
              {officeLocations.map((office, index) => (
                <div key={index} className="enhanced-office-card">
                  <div className="office-main-content">
                    <div className="office-image">
                      <div className="google-map-container">
                        <iframe
                          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3691.5!2d71.2183!3d21.6061!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395880c0e23d9609%3A0xf9a8f06e25e529c!2sS-5%2C%20Global%20Solar%20Energy%2C%20Shivam%20plaza%2C%20Old%2C%20Market%20Yard%20Rd%2C%20Amreli%20Irrigation%20Division%2C%20D.L.B.%20Society%2C%20Amreli%2C%20Gujarat%20365601!5e0!3m2!1sen!2sin!4v1734693327000!5m2!1sen!2sin"
                          width="100%"
                          height="100%"
                          style={{ border: 0, borderRadius: '12px' }}
                          allowFullScreen=""
                          loading="lazy"
                          referrerPolicy="no-referrer-when-downgrade"
                          title="Global Solar Energy Office Location - S-5, Shivam Plaza, Amreli"
                        ></iframe>
                      </div>
                    </div>
                    <div className="office-content">
                      <h3>{office.city}</h3>
                      <p className="office-description">
                        Our modern solar center in Amreli is equipped with the latest solar technology displays,
                        expert consultation rooms, and comprehensive solar solutions for residential and commercial needs.
                      </p>
                      <div className="office-details">
                        <div className="office-detail">
                          <i className="fas fa-map-marker-alt"></i>
                          <span>{office.address}</span>
                        </div>
                        <div className="office-detail">
                          <i className="fas fa-phone"></i>
                          <a href={`tel:${office.phone}`}>{office.phone}</a>
                        </div>
                        <div className="office-detail">
                          <i className="fas fa-envelope"></i>
                          <a href={`mailto:${office.email}`}>{office.email}</a>
                        </div>
                        <div className="office-detail">
                          <i className="fas fa-clock"></i>
                          <span>Monday - Saturday: 10:00 AM - 7:00 PM</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  {/* Services Available */}
                  <div className="office-services">
                    <h4>Services Available at Our Center</h4>
                    <div className="services-grid">
                      <div className="service-item">
                        <i className="fas fa-calculator"></i>
                        <span>Free Solar Assessment</span>
                      </div>
                      <div className="service-item">
                        <i className="fas fa-eye"></i>
                        <span>Live Solar Panel Display</span>
                      </div>
                      <div className="service-item">
                        <i className="fas fa-file-contract"></i>
                        <span>Documentation Support</span>
                      </div>
                      <div className="service-item">
                        <i className="fas fa-tools"></i>
                        <span>Technical Consultation</span>
                      </div>
                      <div className="service-item">
                        <i className="fas fa-rupee-sign"></i>
                        <span>Financing Options</span>
                      </div>
                      <div className="service-item">
                        <i className="fas fa-headset"></i>
                        <span>After-Sales Support</span>
                      </div>
                    </div>
                  </div>
                  
                  {/* Visit Information */}
                  <div className="visit-info">
                    <div className="visit-card">
                      <h4>Plan Your Visit</h4>
                      <p>Schedule a visit to our solar center for personalized consultation and see our solar solutions in action.</p>
                      <div className="visit-features">
                        <div className="visit-feature">
                          <i className="fas fa-car"></i>
                          <span>Free Parking Available</span>
                        </div>
                        <div className="visit-feature">
                          <i className="fas fa-coffee"></i>
                          <span>Complimentary Refreshments</span>
                        </div>
                        <div className="visit-feature">
                          <i className="fas fa-user-tie"></i>
                          <span>Expert Solar Consultants</span>
                        </div>
                      </div>
                      <div className="visit-actions">
                        <a href={`mailto:${office.email}`} className="btn btn-primary">
                          <i className="fas fa-envelope"></i>
                          Email Us
                        </a>
                        <a href={`tel:${office.phone}`} className="btn btn-primary">
                          <i className="fas fa-phone"></i>
                          Call to Schedule
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* Customer Care Contact List */}
        <CustomerCareTable />
      </div>
    </>
  );
};

export default Contact;